<script>
import Breadcrumbs from "@js/components/Breadcrumbs/Breadcrumbs.vue";
import MobileTopBar from "@js/components/TopBar/MobileTopBar.vue";
import {contacts, requisites} from "@js/company_details.ts";
import {Link} from "@inertiajs/vue3";

export default {
    name: "PublicOfferPage",
    components: {Link, MobileTopBar, Breadcrumbs},
    methods: {
        formatPhone(number) {
            if (!number) return "";
            return number.replace(/^7(\d{3})(\d{3})(\d{2})(\d{2})$/, "+7 ($1) $2-$3-$4");
        },
    },
    setup() {
        return {
            contacts, requisites
        }
    }
}
</script>

<template>
    <MobileTopBar/>
    <div class="container">
        <Breadcrumbs class="mb-2"/>
        <h1 class="text-2xl md:text-3xl">Публичная оферта</h1>
        <hr class="mt-5 mb-5"/>

        <!-- Основные понятия -->
        <div class="mb-10">
            <h2 class="text-xl font-medium mb-5">Основные понятия</h2>
            <p class="text-sm mb-2">
                <span class="font-bold text-base">Посетитель Сайта</span> — лицо, пришедшее на сайт
                https://moda-ceramics.store без цели размещения Заказа.
            </p>
            <p class="text-sm mb-2">
                <span class="font-bold text-base">Пользователь</span> — физическое лицо, посетитель Сайта, принимающий
                условия настоящей Оферты и желающий разместить Заказы в Интернет-магазине.
            </p>
            <p class="text-sm mb-2">
                <span class="font-bold text-base">Покупатель</span> — Пользователь, разместивший Заказ в
                Интернет-магазине.
            </p>
            <p class="text-sm mb-2">
                <span class="font-bold text-base">MODA CERAMICS</span> — Общество с ограниченной ответственностью «МОДА
                КЕРАМИКС РУС», ИНН {{ requisites.inn }}, КПП {{ requisites.kpp }}, ОГРН {{ requisites.ogrn }}.
            </p>
            <p class="text-sm mb-2">
                <span class="font-bold text-base">Юридический адрес:</span>
                {{ requisites.ur_address }}
            </p>
            <p class="text-sm mb-2">
                <span class="font-bold text-base">Продавец</span> — ООО «МОДА КЕРАМИКС РУС» или иное юридическое
                лицо/ИП, размещающее товары на сайте.
            </p>
            <p class="text-sm mb-2">
                <span class="font-bold text-base">Интернет-магазин</span> — сайт https://moda-ceramics.store, где
                размещены товары, условия оплаты и доставки.
            </p>
            <p class="text-sm mb-2">
                <span class="font-bold text-base">Сайт</span> — https://moda-ceramics.store
            </p>
            <p class="text-sm mb-2">
                <span class="font-bold text-base">Товар</span> — плитка, керамогранит, мозаика, ступени, напольные покрытия, сантехника и сопутствующие
                товары.
            </p>
            <p class="text-sm mb-2">
                <span class="font-bold text-base">Заказ</span> — оформленный запрос на покупку и доставку товара по
                адресу или самовывозом.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">1. Общие положения</h2>
            <p class="text-sm mb-2"> 1.1. Продавец осуществляет продажу Товаров через Интернет-магазин по адресу
                https://moda-ceramics.store/. </p>
            <p class="text-sm mb-2">
                1.2. Заказывая Товары через Интернет-магазин, Пользователь соглашается с условиями продажи Товаров,
                изложенными ниже (далее — Условия продажи товаров). В случае несогласия с настоящим Пользовательским
                соглашением (далее — Соглашение / Публичная оферта) Пользователь обязан немедленно прекратить
                использование сервиса и покинуть сайт https://moda-ceramics.store/.
            </p>
            <p class="text-sm mb-2">
                1.3. Настоящие Условия продажи товаров, а также информация о Товаре, представленная на Сайте, являются
                публичной офертой в соответствии со ст.435 и п.2 ст.437 Гражданского кодекса Российской Федерации.
            </p>
            <p class="text-sm mb-2">
                1.4. Соглашение может быть изменено Продавцом в одностороннем порядке без уведомления
                Пользователя/Покупателя. Новая редакция Соглашения вступает в силу по истечении 10 (десяти) календарных
                дней с момента ее опубликования на Сайте, если иное не предусмотрено условиями настоящего Соглашения.
            </p>
            <p class="text-sm mb-2">
                1.5. Публичная оферта признается акцептованной Посетителем Сайта / Покупателем с момента регистрации
                Посетителя на Сайте, оформления Покупателем Заказа без авторизации на Сайте, а также с момента принятия
                от Покупателя Заказа по телефону {{ formatPhone(contacts.first_phone) }} или по почте {{ contacts.info_mail }}.
                Договор розничной купли-продажи считается заключенным с момента выдачи Продавцом Покупателю кассового
                или товарного чека либо иного документа, подтверждающего оплату товара. Сообщая Продавцу свой e-mail и
                номер телефона, Посетитель Сайта/Пользователь/Покупатель дает согласие на использование указанных
                средств связи Продавцом, а также третьими лицами, привлекаемыми им для целей выполнения обязательств
                перед Посетителями Сайта/Пользователями/Покупателями, в целях осуществления рассылок рекламного и
                информационного характера, содержащих информацию о скидках, предстоящих и действующих акциях и других
                мероприятиях Продавца, о передаче заказа в доставку, а также иную информацию, непосредственно связанную
                с выполнением обязательств Покупателем в рамках настоящей Публичной оферты.
            </p>
            <p class="text-sm mb-2">
                1.6. Осуществляя Заказ, Пользователь/Покупатель соглашается с тем, что Продавец может поручить
                исполнение Договора третьему лицу, при этом оставаясь ответственным за его исполнение.
            </p>
            <p class="text-sm mb-2">
                1.7. В рамках Заказа Продавец предоставляет Пользователю информационное сопровождение заключенного
                Пользователем с Продавцом Договора.
            </p>
        </div>
        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">2. Регистрация на сайте</h2>
            <p class="text-sm mb-2">
                2.1. Регистрация на Сайте осуществляется с помощью вкладки «Регистрация».
            </p>
            <p class="text-sm mb-2">
                2.2. Регистрация на Сайте не является обязательной для оформления Заказа.
            </p>
            <p class="text-sm mb-2">
                2.3. Продавец не несет ответственности за точность и правильность информации, предоставляемой
                Пользователем при регистрации.
            </p>
            <p class="text-sm mb-2">
                2.4. Пользователь обязуется не сообщать третьим лицам логин и пароль, указанные Пользователем при
                регистрации. В случае возникновения у Пользователя подозрений относительно безопасности его логина и
                пароля или возможности их несанкционированного использования третьими лицами, Пользователь обязуется
                незамедлительно уведомить об этом Продавца, направив соответствующее электронное письмо по адресу:
                {{ contacts.info_mail }}
            </p>
            <p class="text-sm mb-2">
                2.5. Общение Пользователя/Покупателя с операторами Call-центра / менеджерами и иными представителями
                Продавца должно строиться на принципах общепринятой морали и коммуникационного этикета. Строго запрещено
                использование нецензурных слов, брани, оскорбительных выражений, а также угроз и шантажа, в
                независимости от того, в каком виде и кому они были адресованы.
            </p>
        </div>
        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">3. Товар и порядок совершения покупки</h2>
            <p class="text-sm mb-2">
                3.1. Сопровождающие Товар фотографии являются простыми иллюстрациями к нему и могут отличаться от
                фактического внешнего вида Товара. Сопровождающие Товар описания/характеристики не претендуют на
                исчерпывающую информативность и могут содержать опечатки. Для уточнения информации по Товару Покупатель
                должен обратиться в Службу поддержки клиентов.
            </p>
            <p class="text-sm mb-2">
                3.2. В случае отсутствия заказанных Покупателем Товаров на складе Продавца, последний вправе исключить
                указанный Товар из Заказа / аннулировать Заказ Покупателя, уведомив об этом Покупателя путем направления
                соответствующего электронного сообщения по адресу, указанному Покупателем при регистрации.
            </p>
            <p class="text-sm mb-2">
                3.3. В случае аннуляции полностью либо частично предоплаченного Заказа стоимость аннулированного Товара
                возвращается Продавцом Покупателю способом, которым Товар был оплачен.
            </p>
            <p class="text-sm mb-2">
                3.4. Покупатель несет полную ответственность за предоставление неверных сведений, повлекшее за собой
                невозможность надлежащего исполнения Продавцом своих обязательств перед Покупателем.
            </p>
            <p class="text-sm mb-2">
                3.5. После оформления Заказа на Сайте Покупателю предоставляется информация о предполагаемой дате
                доставки путем направления электронного сообщения по адресу, указанному Покупателем при регистрации, или
                по телефону. Менеджер, обслуживающий данный Заказ, уточняет детали Заказа, согласовывает дату доставки,
                которая зависит от наличия товара на складе и ожидаемых сроков его поступления, а так же от загрузки
                отдела логистики и иных причин, не связанных с Продавцом.
            </p>
            <p class="text-sm mb-2">
                3.6. Ожидаемая дата передачи Заказа в Службу доставки Продавца сообщается Покупателю менеджером,
                обслуживающим Заказ, по электронной почте или при контрольном звонке Покупателю. Дата передачи Товара
                может быть изменена Продавцом в одностороннем порядке в случае наличия объективных, по мнению Продавца,
                причин.
            </p>
        </div>
        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">4. Доставка заказа</h2>
            <p class="text-sm mb-2">
                4.1. Способы доставки Товаров, реализуемых Продавцом, указаны на Сайте в разделе «Доставка» по адресу
                <Link :href="route('deliveryAndShipping')"
                      class="underline hover:text-navHoverColor leading-tight transition font-bold">
                https://moda-ceramics.store/delivery-and-shipping
                </Link>.
            </p>
            <p class="text-sm mb-2">
                4.2. Территория доставки Товаров, представленных на Сайте и реализуемых Продавца, ограничена пределами
                города Москва и Московской области. Доставка в другие регионы/страны осуществляется путем передачи
                заказа сторонней логистической компании. Продавец не несет ответственности за качество услуг по доставке
                продукции оказанной сторонней компанией.
            </p>
            <p class="text-sm mb-2">
                4.3. Задержки в доставке возможны ввиду непредвиденных обстоятельств, произошедших не по вине Продавца.
            </p>
            <p class="text-sm mb-2">
                4.4. При доставке Заказ вручается Покупателю либо третьему лицу, указанному в Заказе в качестве
                получателя (далее Покупатель и третье лицо именуются «Получатель»). При невозможности получения Заказа,
                оплаченного посредством наличного расчета, указанными выше лицами, Заказ может быть вручен лицу, который
                может предоставить сведения о Заказе (номер отправления и/или ФИО Получателя), а также оплатить
                стоимость Заказа в полном объеме лицу, осуществляющему доставку Заказа.
            </p>
            <p class="text-sm mb-2">
                4.5. Во избежание случаев мошенничества, а также для выполнения взятых на себя обязательств, указанных в
                пункте 4. настоящего Соглашения, при вручении предоплаченного Заказа лицо, осуществляющее доставку
                Заказа, вправе затребовать документ, удостоверяющий личность Получателя, а также указать тип и номер
                предоставленного Получателем документа на квитанции к Заказу. Продавец гарантирует конфиденциальность и
                защиту персональных данных Получателя (п.9.3.).
            </p>
            <p class="text-sm mb-2">
                4.6. Риск случайной гибели или случайного повреждения Товара переходит к Покупателю с момента передачи
                ему Заказа и проставления Получателем Заказа подписи в документах, подтверждающих доставку Заказа. В
                случае недоставки Заказа Продавец возмещает Покупателю стоимость предоплаченного Покупателем Заказа и
                доставки в полном объеме после получения от Службы доставки подтверждения утраты Заказа.
            </p>
            <p class="text-sm mb-2">
                4.7. Стоимость доставки каждого Заказа рассчитывается индивидуально, исходя из сведений о Продавце
                заказанного Товара, веса Товара, региона и способа доставки, а также (в случае необходимости) формы
                оплаты, и указывается на Сайте на последнем этапе оформления Заказа.
            </p>
            <p class="text-sm mb-2">
                4.8. Обязанность Продавца передать товар Покупателю считается исполненной в момент вручения курьером
                Товара Получателю или получения Товара Получателем в отделении почтовой связи либо в заранее оговоренном
                месте выдачи Заказа (в т.ч. в пункте самовывоза).
                При получении Заказа Получатель после оплаты доставленного Товара обязан осмотреть доставленный Товар и
                произвести его вскрытие в присутствии работников Продавца для проверки Товара на соответствие
                заявленному количеству, ассортименту и комплектности Товара, а также проверить срок службы доставленного
                Товара и целостность упаковки. В случае наличия претензий к доставленному Товару (недовложение, вложение
                Товара, производственный брак, иные претензии) по указанию Получателя работниками Продавца составляется
                Акт о выявленных несоответствиях. Если Получателем не были заявлены претензии в вышеуказанном порядке,
                то Продавец считается полностью и надлежащим образом исполнившим свою обязанность по передаче Товара.
                <br/>
                При принятии Заказа от курьера или водителя, далее курьера, Получатель обязан осмотреть доставленный
                Товар и проверить его на соответствие заявленному количеству, ассортименту и комплектности Товара, а
                также проверить срок службы доставленного Товара и целостность упаковки. В случае отсутствия претензий к
                доставленному Товару Получатель расписывается в «Бланке доставки заказов» либо ином аналогичном
                документе, предоставляемом курьером, и оплачивает Заказ (в отсутствие 100-процентной предоплаты).
                Подпись в доставочных документах свидетельствует о том, что претензий к Товару Получателем не заявлено и
                Продавец полностью и надлежащим образом выполнил свою обязанность по передаче Товара.
                <br/>
                Время нахождения курьеров, доставляющих товар, реализуемый Продавцом, по адресу Получателя ограничено 20
                минутами. Время нахождения курьеров, доставляющих товар, реализуемый иными Продавцами, может отличаться
                как в большую, так и в меньшую сторону в зависимости от условий доставки Товара соответствующего
                Продавца.
                <br/>
                Товар, представленный на Сайте, по качеству и упаковке соответствует ГОСТ и ТУ, что подтверждается
                соответствующими документами (сертификатами и т.д.).
                <br/>
                Уточнить дату, время и при необходимости маршрут доставки, можно у менеджера, который связывается с
                Покупателем для подтверждения Заказа.
                <br/>
                Пользователь понимает и соглашается с тем, что: осуществление доставки — отдельная услуга, не являющаяся
                неотъемлемой частью приобретаемого Покупателем Товара, выполнение которой заканчивается в момент
                получения Получателем Товара и осуществления платежа за него. Претензии к качеству приобретенного
                Товара, возникшие после получения и оплаты Товара, рассматриваются в соответствии с Законом РФ «О защите
                прав потребителей», Гражданским кодексом РФ и гарантийными обязательствами соответствующего
                Производителя. В связи с этим приобретение Товара с доставкой не дает Покупателю право требования
                доставки приобретенного Товара в целях гарантийного обслуживания или замены, не дает возможности
                осуществлять гарантийное обслуживание или замену Товара посредством выезда к Покупателю и не
                подразумевает возможность возврата стоимости доставки Товара в случаях, когда Покупатель имеет право на
                возврат денег за Товар как таковой, в соответствии с Законом РФ «О защите прав потребителей».
            </p>
        </div>
        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">5. Оплата товара</h2>
            <p class="text-sm mb-2">
                Цена товара, реализуемого в Интернет-магазине, указывается в рублях Российской Федерации и включает в
                себя налог на добавленную стоимость.
                <br/>
                Цена Товара указывается на Сайте. В случае неверного указания цены заказанного Покупателем Товара,
                Продавец информирует об этом Покупателя для подтверждения Заказа по исправленной цене либо аннулирования
                Заказа. При невозможности связаться с Покупателем данный Заказ считается аннулированным. Если Заказ был
                оплачен, Продавец возвращает Покупателю оплаченную за Заказ сумму тем же способом, которым она была
                уплачена.
                <br/>
                Цена Товара на Сайте может быть изменена Продавцом в одностороннем порядке. При этом цена на заказанный
                Покупателем Товар изменению не подлежит. Цена Товара может дифференцироваться по регионам.
            </p>
            <p class="text-sm mb-2 font-bold">
                5.1. Особенности оплаты Товара с помощью банковских карт:
            </p>
            <p class="text-sm mb-2">
                5.1.1. В соответствии с положением ЦБ РФ «Об эмиссии платежных карт и об операциях, совершаемых с их
                использованием" (утв. Банком России 24.12.2004 № 266-П) операции по банковским картам совершаются
                держателем карты либо уполномоченным им лицом.
            </p>
            <p class="text-sm mb-2">
                5.1.2. Авторизация операций по банковским картам осуществляется банком. Если у банка есть основания
                полагать, что операция носит мошеннический характер, то банк вправе отказать в осуществлении данной
                операции. Мошеннические операции с банковскими картами попадают под действие статьи 159 УК РФ.
            </p>
            <p class="text-sm mb-2">
                5.1.3. Во избежание случаев различного рода неправомерного использования банковских карт при оплате все
                Заказы, оформленные на Сайте и предоплаченные банковской картой, проверяются Продавцом. В целях проверки
                личности владельца и его правомочности на использование карты Продавец вправе потребовать от Покупателя,
                оформившего такой заказ, предъявления документа, удостоверяющего личность.
                <br/>
                Продавец вправе предоставлять скидки на Товары и устанавливать программу бонусов. Виды скидок, бонусов,
                порядок и условия начисления определяются Продавцами самостоятельно и указаны на Сайте и могут быть
                изменены Продавцом в одностороннем порядке.
                <br/>
                В случае если при применении скидки / бонуса пересчитанная стоимость Товара включает в себя копейки,
                такая стоимость Товара подлежит округлению в соответствии с математическими правилами округления.
                <br/>
                При проведении маркетинговых мероприятий, предполагающих вложение каких-либо объектов в отправления с
                Заказом Покупателя, доставка указанных вложений осуществляется за счет Покупателя. Для того, чтобы
                отказаться от вложения, Покупателю необходимо обратиться в call-center.
                <br/>
                Заказ считается неукомплектованным, если Покупатель сообщил об изменении решения о покупке до момента
                начала сборки заказа на складе. Если Покупатель сообщил Продавцу об этом после момента начала сборки
                заказа на складе, то такой Заказ считается отклоненным.
            </p>
        </div>
        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">
                6.1. Возврат товара и денежных средств в соответствии с Законом «О защите прав потребителей»
            </h2>
            <p class="text-sm mb-2">
                6.1.1. При оформлении договора купли-продажи Покупатель получает от Продавца полный и достоверный объём
                информации о Товаре. Оплата Товара означает достаточное и полное ознакомление Покупателя с условиями
                продажи, в том числе о наличии скидок и гарантийных сроков.
            </p>
            <p class="text-sm mb-2">
                6.1.2. Расчет количества плитки может производиться Продавцом по исходным данным, предоставленным
                Покупателем, является консультативной услугой и не может быть причиной для претензии Покупателя. На
                выложенную плитку претензии (тон, калибр, цвет и т.д.) не принимаются.
            </p>
            <p class="text-sm mb-2">
                6.1.3. Количество, комплектность, качество и соответствие Товара документам проверяется Покупателем в
                момент
                отгрузки со склада Продавца или приемки товара при доставке Покупателю. В случае отказа от товара во
                время доставки Покупателю, стоимость доставки оплачивается Покупателем полностью.
            </p>
            <p class="text-sm mb-2">
                6.1.4. После подписания документов отгрузки Покупатель не может предъявлять претензии о некомплектности
                и
                целостности Товара. Подписанный отгрузочный документ (Расходная накладная, Универсальный передаточный
                документ) означает согласие на получение товара в надлежащем качестве, количестве и комплектности.
            </p>
            <p class="text-sm mb-5">
                6.1.5. Покупатель вправе отказаться от товара в любое время до его передачи, а после передачи товара — в
                течение семи дней. Возврат товара надлежащего качества возможен в случае, если указанный товар не был в
                употреблении, сохранены его товарный вид, потребительские свойства, пломбы, фабричные ярлыки, имеется
                документ, подтверждающий факт и условия покупки указанного товара, а также гражданский паспорт
                Покупателя. Возврат Товара производится согласно условиям продажи: плитка — коробками, декоративные
                элементы — поштучно. Возврат или обмен Товара осуществляется силами и за счет Покупателя на склад
                организации.
            </p>
            <p class="text-sm mb-2 font-bold">
                6.2. Способы и порядок возврата товара:
            </p>
            <p class="text-sm mb-2">
                6.2.1. Покупатель не вправе отказаться от Товара надлежащего качества, имеющего индивидуально
                определенные
                свойства, если указанный Товар может быть использован исключительно приобретающим его Покупателем.
            </p>
            <p class="text-sm mb-2">
                6.2.2. При отказе Покупателя от Товара Продавец возвращает ему стоимость возвращенного Товара, за
                исключением расходов продавца на доставку от Покупателя возвращенного Товара, не позднее чем через 10
                дней с даты получения Продавцом письменного заявления Покупателя и Товара. Заявление признается поданным
                в надлежащей форме, если оно составлено в письменном виде с собственноручной подписью Покупателя.
                Заявление Покупателя на возврат передается одновременно с Товаром, от которого Покупатель отказывается,
                а также с предоставлением документа, удостоверяющего личность покупателя (либо нотариальная доверенность
                на представителя), фискальный документ об оплате (чек), упаковка.
            </p>
            <p class="text-sm mb-2">
                6.2.3. В течение 14 календарных дней (при заключении договора купли-продажи дистанционным способом — 7
                дней)
                с момента получения Товара, не считая дня передачи Товара, Покупатель вправе обменять Товар надлежащего
                качества на аналогичный Товар, если указанный Товар не подошел Покупателю по форме, габаритам, фасону,
                расцветке, размеру или комплектации. Покупатель не вправе обменять Товары надлежащего качества,
                указанные в Перечне непродовольственных товаров надлежащего качества, не подлежащих возврату или обмену,
                утвержденном Постановлением Правительства РФ от 19.01.1998 № 55.
            </p>
            <p class="text-sm mb-2">
                6.2.4. Обмен Товара осуществляется путем возврата Товара Продавцу, последующей аннуляции Заказа или
                Товара,
                затем оформления нового Заказа. При этом аннуляция является техническим действием и не подразумевает
                отказ Продавца от исполнения договора.
            </p>
            <p class="text-sm mb-2">
                6.2.5. Если на момент обращения Покупателя аналогичный Товар отсутствует в продаже у Продавца,
                Покупатель
                вправе отказаться от исполнения договора купли-продажи и потребовать возврата уплаченной за указанный
                Товар денежной суммы. Продавец обязан вернуть уплаченную за возвращенный Товар денежную сумму в течение
                10 дней со дня получения возвращенного Покупателем Товара и необходимых документов.
            </p>
            <p class="text-sm mb-2">
                6.2.6. Обмен или возврат Товара надлежащего качества проводится, если указанный Товар не был в
                употреблении,
                сохранены его товарный вид, потребительские свойства, пломбы, фабричные ярлыки, упаковка и т.п. При
                обнаружении следов эксплуатации Товара (в том числе отсутствия или следов переклейки штрих-кода,
                нарушения пломбы и т.д.), Продавец оставляет за собой право отказать в возврате денежных средств по
                данному основанию.
            </p>
            <p class="text-sm mb-2">
                6.2.7. В случае если Покупатель осуществил оплату за товар в порядке безналичного расчета, возврат
                денежных
                средств осуществляется таким же способом.
            </p>
            <p class="text-sm mb-2">
                6.2.8. При передаче Товара Покупатель обязан проверить количество Товаров в Заказе. Если при передаче
                Заказа
                Покупателем обнаружены расхождения по количеству Товара в Заказе, Покупатель обязан в присутствии
                представителя Продавца или перевозчика составить Акт по форме ТОРГ-2, а также иной документ
                установленной формы, подтверждающий недовложение.
            </p>
            <p class="text-sm mb-2">
                6.2.9. Если Продавец передал Покупателю меньшее количество Товара, чем определено Заказом
                (недовложение),
                Покупатель при передаче Заказа вправе принять Товар в части, соответствующей Заказу, и потребовать
                передать недостающее количество Товара, либо, отказаться от Заказа в части недостающего Товара и
                потребовать возврата денежных средств за недостающий Товар.
            </p>
            <p class="text-sm mb-2">
                6.2.10. Передача недостающего Товара осуществляется посредством оформления нового Заказа по согласованию
                сторон — Продавцом либо Покупателем, при условии предоставления Покупателем Акта по форме ТОРГ-2,
                составленного в порядке п.8.
            </p>
            <p class="text-sm mb-2">
                6.2.11. В случае невозможности передать недостающий Товар, Продавец уведомляет об этом Покупателя
                посредством направления сообщения на электронный адрес, указанный Покупателем при регистрации, а
                денежные средства, фактически оплаченные за недостающий товар, возвращаются.
            </p>
            <p class="text-sm mb-2">
                6.2.12. В случае отсутствия Акта по форме ТОРГ-2, Продавец вправе отказать Покупателю в удовлетворении
                претензий по количеству переданного Товара.
            </p>
            <p class="text-sm mb-2">
                6.2.13. Возвращаемые денежные средства могут быть использованы Покупателем для оплаты последующих
                заказов,
                либо по письменному заявлению Покупателя могут быть перечислены на расчетный счет Покупателя, указанного
                в заявлении, которое также должно содержать поручение о возврате денежных средств, уплаченных за Товар,
                и указание банковских реквизитов, по которым должно быть произведено перечисление.
            </p>
        </div>
        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">7. Ответственность</h2>
            <p class="text-sm mb-2">
                Продавец не несет ответственности за ущерб, причиненный Покупателю вследствие ненадлежащего
                использования Товаров, приобретенных в Интернет-магазине.
                <br/>
                Продавец не несет ответственности за содержание и функционирование внешних сайтов. ООО «МОДА КЕРАМИКС РУС» не
                несут ответственности за качество Товара, реализуемого иными Продавцами, а также за исполнение ими своих
                обязательств, по передаче Покупателю Товара, по своей комплектности и количеству соответствующего
                оформленному Покупателем Заказу. Покупатель настоящим соглашается, что любые претензии относительно
                качества, количества и комплектности Товара, а также сроков доставки Товара подлежат направлению тому
                продавцу, чей Товар был заказан в Интернет-магазине.
                <br/>
                При этом ООО «МОДА КЕРАМИКС РУС» обязуются оказывать содействие Покупателям в разрешении их претензий к Продавцам
                путем предоставления всей имеющейся у ООО «МОДА КЕРАМИКС РУС» информации относительно порядка работы, условиях
                продажи и возврата Товара, места нахождения соответствующих Продавцов, а также любой иной информации
                существенной для разрешения таких претензий, находящейся в распоряжении ООО «МОДА КЕРАМИКС РУС» и не являющейся
                конфиденциальной в силу закона либо договора.
            </p>
        </div>
        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">8. Конфиденциальность и защита информации</h2>
            <p class="text-sm mb-5">
                Персональные данные Пользователя/Покупателя обрабатывается в соответствии с ФЗ «О персональных данных» №
                152-ФЗ.
                <br/>
                При регистрации на Сайте Пользователь предоставляет следующую информацию: Фамилия, Имя, контактный номер
                телефона, адрес электронной почты.
                <br/>
                Предоставляя свои персональные данные Продавцу, Посетитель Сайта/Пользователь/Покупатель соглашается на
                их обработку Продавцом, в том числе в целях выполнения Продавцом обязательств перед Посетителем
                Сайта/Пользователем/Покупателем в рамках настоящей Публичной оферты, продвижения Продавцом товаров и
                услуг, проведения электронных и SMS-опросов, контроля результатов маркетинговых акций, клиентской
                поддержки, организации доставки товара Покупателям, проведение розыгрышей призов среди Посетителей
                Сайта/Пользователей/ Покупателей, контроля удовлетворенности Посетителя Сайта/Пользователя/Покупателя, а
                также качества услуг, оказываемых Продавцом.
                <br/>
                Под обработкой персональных данных понимается любое действие (операция) или совокупность действий
                (операций), совершаемых с использованием средств автоматизации или без использования таких средств с
                персональными данными, включая сбор, запись, систематизацию, накопление, хранение, уточнение
                (обновление, изменение) извлечение, использование, передачу (в том числе передачу третьим лицам, не
                исключая трансграничную передачу, если необходимость в ней возникла в ходе исполнения обязательств),
                обезличивание, блокирование, удаление, уничтожение персональных данных.
            </p>
            <p class="text-sm mb-2">
                8.1. Продавец имеет право отправлять информационные, в том числе рекламные сообщения, на электронную
                почту и мобильный телефон Пользователя/Покупателя с его согласия, выраженного посредством совершения им
                действий, однозначно идентифицирующих этого абонента и позволяющих достоверно установить его
                волеизъявление на получение сообщения.
                <br/>
                Пользователь/Покупатель вправе отказаться от получения рекламной и другой информации без объяснения
                причин отказа путем информирования ООО «МОДА КЕРАМИКС РУС» о своем отказе по телефону {{ formatPhone(contacts.first_phone) }},
                либо
                посредством направления соответствующего заявления на электронный адрес Продавца:
                {{ contacts.info_mail }}.
            </p>
            <p class="text-sm mb-2">
                8.2. Сервисные сообщения, информирующие Пользователя/Покупателя о заказе и этапах его обработки,
                отправляются автоматически и не могут быть отклонены Пользователем/Покупателем.
            </p>
            <p class="text-sm mb-2">
                8.3. Отзыв согласия на обработку персональных данных осуществляется путем отзыва акцепта настоящей
                Публичной
                оферты в свободной форме. Продавец вправе использовать технологию «cookies». «Cookies» не содержат
                конфиденциальную информацию. Посетитель / Пользователь / Покупатель настоящим дает согласие на сбор,
                анализ
                и использование cookies, в том числе третьими лицами для целей формирования статистики и оптимизации
                рекламных сообщений.
                <br/>
                Продавец получает информацию об ip-адресе посетителя Сайта https://moda-ceramics.store/. Данная
                информация не
                используется для установления личности посетителя. Продавец не несет ответственности за сведения,
                предоставленные Пользователем/Покупателем на Сайте в общедоступной форме. Продавец вправе осуществлять
                записи телефонных разговоров с Пользователем/Покупателем. При этом Продавец обязуется: предотвращать
                попытки
                несанкционированного доступа к информации, полученной в ходе телефонных переговоров, и/или передачу ее
                третьим лицам, не имеющим непосредственного отношения к исполнению Заказов, в соответствии с п.4 ст.16
                Федерального закона «Об информации, информационных технологиях и о защите информации».
            </p>
        </div>
        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">
                9. Срок действия Публичной оферты
            </h2>
            <p class="text-sm mb-2">
                Настоящая Публичная оферта вступает в силу с момента ее акцепта Посетителем Сайта/Покупателем, и
                действует до момента отзыва акцепта Публичной оферты.
            </p>
        </div>
        <div>
            <h2 class="text-xl mb-5 font-medium">
                10. Дополнительные условия
            </h2>
            <p class="text-sm mb-2">
                Продавец вправе переуступать либо каким-либо иным способом передавать свои права и обязанности,
                вытекающие из его отношений с Покупателем, третьим лицам.
                <br/>
                Интернет-магазин и предоставляемые сервисы могут быть временно частично или полностью недоступны по
                причине проведения профилактических или иных работ или по любым другим причинам технического характера.
                Техническая служба Продавца имеет право периодически проводить необходимые профилактические или иные
                работы с предварительным уведомлением Покупателей или без такового. К отношениям между
                Пользователем/Покупателем и Продавцом применяются положения российского законодательства.
                <br/>
                В случае возникновения вопросов и претензий со стороны Пользователя/Покупателя он должен обратиться к
                Продавцу по телефону или иным доступным способом. Все возникающее споры стороны будут стараться решить
                путем переговоров, при недостижении соглашения спор будет передан на рассмотрение в судебный орган в
                соответствии с действующим законодательством РФ.
                <br/>
                Признание судом недействительности какого-либо положения настоящего Соглашения не влечет за собой
                недействительность остальных положений.
            </p>
        </div>
    </div>
</template>

<style scoped lang="scss">
.prose a {
    @apply text-yellow-600 hover:text-yellow-800 underline;
}
</style>
